{% block sw_sales_channel_detail_base_general_input_product_comparison_template %}
    <template v-if="!isAgenticCommerceType">
        {% parent %}
    </template>
{% endblock %}

{% block sw_sales_channel_detail_base_general_input_product_comparison_filename %}
    <template v-if="!isAgenticCommerceType">
        {% parent %}
    </template>
{% endblock %}

{% block sw_sales_channel_detail_base_general_input_product_comparison_encoding %}
    <template v-if="!isAgenticCommerceType">
        {% parent %}
    </template>
{% endblock %}

{% block sw_sales_channel_detail_base_general_input_product_comparison_storefront_select %}
    <template v-if="isAgenticCommerceType">
        <sw-entity-single-select
            v-model:value="productExport.storefrontSalesChannelId"
            class="sw-sales-channel-detail__product-comparison-storefront"
            :label="$t('sw-sales-channel.detail.productComparison.storefront')"
            :help-text="$t('swag-paypal-agentic-commerce.sales-channel.detail.storefrontHelpText')"
            :criteria="agenticStorefrontSalesChannelCriteria"
            label-property="name"
            :disabled="!acl.can('sales_channel.editor') || undefined"
            value-property="id"
            entity="sales_channel"
            required
            show-clearable-button
            :error="productExportStorefrontSalesChannelIdError"
            @update:value="onStorefrontSelectionChange"
        />
    </template>

    <template v-else>
        {% parent %}
    </template>
{% endblock %}

{% block sw_sales_channel_detail_base_general_input_product_comparison_file_format %}
    <template v-if="!isAgenticCommerceType">
        {% parent %}
    </template>
{% endblock %}

{% block sw_sales_channel_detail_base_options_status_description %}
    <template v-if="isAgenticCommerceType">
        <div class="sw-sales-channel-detail-base__description-text">
            {{ $t('swag-paypal-agentic-commerce.sales-channel.detail.textActiveDescription') }}
        </div>
    </template>
{% endblock %}

{% block sw_sales_channel_detail_base_options_api %}
    <template v-if="!isAgenticCommerceType">
        {% parent %}
    </template>
{% endblock %}

{% block sw_sales_channel_detail_base_options_maintenance_header %}
    <template v-if="!isAgenticCommerceType">
        {% parent %}
    </template>
{% endblock %}

{% block sw_sales_channel_detail_base_maintenance_input_active %}
    <template v-if="!isAgenticCommerceType">
        {% parent %}
    </template>
{% endblock %}

{% block sw_sales_channel_detail_base_maintenance_ipwhitelist %}
    <template v-if="!isAgenticCommerceType">
        {% parent %}
    </template>
{% endblock %}

{% block sw_sales_channel_detail_base_settings_link %}
    <template v-if="!isAgenticCommerceType">
        {% parent %}
    </template>
{% endblock %}

{% block sw_sales_channel_detail_base_options_delete %}
    <mt-card
        v-if="isAgenticCommerceType"
        class="swag-paypal-settings-webhook"
        position-identifier="swag-paypal-settings-webhook"
    >
        <template #title>
            <div class="swag-paypal-settings-webhook__title">
                <p>
                    {{ $t('swag-paypal-settings.webhook.title') }}
                </p>

                <sw-label
                    class="swag-paypal-settings-webhook__label"
                    appearance="pill"
                    size="medium"
                    :variant="webhookStatusVariant"
                >
                    <sw-color-badge :rounded="true" :variant="webhookStatusVariant" />
                    <span>{{ webhookStatusLabel }}</span>
                </sw-label>
            </div>
        </template>

        <div class="swag-paypal-settings-webhook__content">
            <span class="swag-paypal-settings-webhook__info-text">
                {{ $t('swag-paypal-settings.webhook.honey.info') }}
            </span>

            <mt-button
                class="swag-paypal-settings-webhook__refresh-button"
                variant="secondary"
                :disabled="!salesChannel.active"
                :is-loading="isRefreshingWebhook"
                @click="onRefreshWebhook"
            >
                {{ $t('swag-paypal-settings.webhook.buttonRefresh') }}
            </mt-button>
        </div>
    </mt-card>

    {% parent %}
{% endblock %}
